<template>
    <section class="col-12">
        <label><strong>Sites</strong></label>
        <div class="table">
            <div class="table-responsive">
                <vue-good-table
                    id="table-sites"
                    ref="table-sites"
                    v-if="!loading"
                    :responsive="false"
                    :select-options="{ enabled: !readonly, selectOnCheckboxOnly: true, }"
                    :search-options="{ enabled: false,  placeholder:'Filter'}"
                    @on-selected-rows-change="selectionChanged"
                    @on-cell-click="onCellClick"
                    :sort-options="{
                    enabled: true,
                    initialSortBy: orderDirection ? { field: columns[0].field, type: orderDirection } : null
                }"

                    :columns="columns"
                    :rows="rows">
                    <div slot="table-actions" v-if="!readonly">
                        <div class="btn-group">
                            <!--                        <button v-if="actionsLocal.add" type="button" @click="addRowBlank" title="Manual Add"
                                                            class="btn btn-success action-label" style="font-size: 12px;"><i
                                                        class="fa fa-plus"></i> Add
                                                    </button>-->
                            <button v-if="actionsLocal.add" type="button" title="Find" data-toggle="modal"
                                    data-target="#sitesModal"
                                    data-backdrop="static"
                                    data-keyboard="false" class="btn btn-info action-label" style="font-size: 12px;"><i
                                class="fa fa-plus "></i> Add
                            </button>
                            <button v-if="actionsLocal.remove" type="button" @click="removeSite"
                                    class="btn  btn-danger action-label"
                                    title="Delete"
                                    style="font-size: 12px;"><i class="fa fa-minus"></i> Remove
                            </button>
                            <button v-if="actionsLocal.reset" type="button" @click="removeColumnsStore"
                                    class="btn  btn-warning action-label" title="Reset"
                                    style="font-size: 12px;"><i class="fa fa-undo"></i> Reset
                            </button>
                            <button v-if="actionsLocal.file" type="button" @click="exportExcel"
                                    class="btn  btn-success action-label"
                                    title="Export Excel"
                                    style="font-size: 12px;"><i class="fas fa-file-excel"></i> Export Excel
                            </button>
                            <button v-if="actionsLocal.columns" type="button" data-toggle="modal"
                                    data-target="#columnsModalSite" data-backdrop="static"
                                    title="Customize View"
                                    data-keyboard="false" class="btn btn-secondary action-label"
                                    style="font-size: 12px;"><i
                                class="fa fa-list"></i> Custom
                            </button>
                        </div>
                    </div>
                    <template slot="table-column" slot-scope="props">
                        <span v-html="props.column.label"></span>
                    </template>
                    <template slot="table-row" slot-scope="props">
                   <span v-if="props.column.field === 'custom_field'">
                       <span v-if="customField === 'Contract Type'">
                               <input type="hidden" :name="'contract_types['+props.row.id+'][site_id]'"
                                      :value="props.row.id">
                           <select :name="'contract_types['+props.row.id+'][contract_type_number]'"
                                   class="form-control">
                                    <option
                                        v-for="(contractType, ctIndex) in $store.getters['contract/getInstallments']"
                                        :selected="$store.getters['contract/checkContractTypeNumber'](props.row.id, ctIndex+1)"
                                        :value="ctIndex + 1">{{ ctIndex + 1 }}
                                    </option>
                           </select>
                            </span>
                        <span v-else-if="customField === 'WT#'">
                               <select-view-component v-if="props.row.id"
                                                      :url-show="`/schedules/${extraId}/stn/site/${props.row.id}`"></select-view-component>
                        </span>
                   </span>
                        <span v-else-if="props.column.field === 'actions'">
                       <slot name="actions" :props="props" :columns="columns"></slot>
                   </span>
                        <div v-else-if="props.column.field === 'labor_rate'" class="labor_rate text-center"
                             :class="{'lr-black': props.formattedRow[props.column.field] === 'PT', 'lr-red': props.formattedRow[props.column.field] === 'DT'}">
                            {{ props.formattedRow[props.column.field] }} &nbsp;&nbsp;
                        </div>
                        <span v-else-if="props.column.field === 'site_acc_number'">
                          <select-data-component
                              :initial-value="props.row.id" :name="`site-${Math.random()}`"
                              :key="props.row.site_acc_number || `site-${Math.random()}`"
                              @selected="(val) => {props.row.id = val; getSite(val,props.index)}"
                              table="sites" field-id="id"
                              field-name="site_acc_number">
                          </select-data-component>
                    </span>
                        <span v-else> {{ props.formattedRow[props.column.field] }}</span>
                    </template>
                </vue-good-table>
            </div>
            <!-- Modal -->
            <portal to="destination">
                <div class="modal fade" id="sitesModal" tabindex="-1" role="dialog" ref="resizable"
                     aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-xl" role="document">
                        <div class="modal-content" style="resize: both;">
                            <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLabel">Find Site</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body" style="height: 80vh; overflow-y: scroll;">
                                <generic-select @apply="addSite" @selecteds="setSelecteds"
                                                model="App\Models\Site"></generic-select>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                                <button type="button" class="btn btn-primary" @click="addSite">Done</button>
                            </div>
                            <div class="resizable-handle" ref="handle"></div>
                        </div>
                    </div>
                </div>
            </portal>
            <portal to="destination">
                <div class="modal fade" id="columnsModalSite" tabindex="-1" role="dialog"
                     aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">Columns - Show/Hide</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body" style="max-height: 400px; overflow-y: scroll;">
                                <div class="row">
                                    <div v-for="(column, index) in columns" :key="index" class="col-md-4"
                                         style="border-bottom: 1px solid #DDDDDD">
                                        <a href="#" @click.prevent="setStatusColumn(column)" class="small"
                                           tabIndex="-1">
                                            <span v-if="column.hidden" class="fa fa-eye-slash"></span>
                                            <span v-else class="fa fa-eye text-info"></span>
                                            &nbsp;{{ column.label }}</a>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            </portal>
            <input v-for="row in rows" type="hidden" :name="name+'[]'" :key="row.id" :value="row.id">
        </div>
    </section>
</template>

<script>
import _ from "lodash";
import {URL_BASE} from "../../../utils/helper";
import 'vue-good-table/dist/vue-good-table.css'
import {VueGoodTable} from 'vue-good-table';
import exportFromJSON from 'export-from-json'
import SiteModel from "../../../models/SiteModel";
import SelectViewComponent from "../../SelectViewComponent.vue";

export default {
    name: "Sites",
    props: {
        sites: {
            type: Array,
            default: []
        },
        name: {
            type: String,
            default: 'sites',
            required: false
        },
        actions: {
            type: Object,
            default: null,
            required: false
        },
        customField: {
            type: String,
            default: null,
            required: false
        },
        order: {
            type: String,
            default: 'default',
        },
        orderField: {
            type: String,
            default: "",
        },
        orderDirection: {
            default: 'desc',
        },
        customFieldPosition: {
            type: String,
            default: 'start',
        },
        extraId: {
            default: null,
        },
        trCondition: {
            type: Function,
            default: null,
        },
        readonly: {
            type: Boolean,
            default: false
        },
        month: {
            type: Number,
            default: 0
        },
        year: {
            type: Number,
            default: 0
        },
        period_id: {
            type: Number,
            default: 0
        },
    },

    components: {
        SelectViewComponent,
        VueGoodTable,
    },
    data() {
        return {
            actionsLocal: {
                add: true,
                edit: true,
                reset: true,
                remove: true,
                columns: true,
                file: true,
            },
            columns: [],
            rows: [],
            ids: [],
            selecteds: [],
            orderFieldName: '',
            site_id: null,
            sites_selecteds: [],
            showTable: true,
            loading: true,
            messageId: null,
        };
    },
    async mounted() {
        this.ids = this.sites;
        await this.getSites()
        this.$root.addTypeButton();

        if (this.actions !== null) {
            this.actionsLocal = Object.assign(this.actionsLocal, this.actions);

        }

    },
    methods: {
        tdClassFunc(row) {
            return this.trCondition(row);
        },
        toggleColumn(index, event) {
            this.$set(this.columns[index], 'hidden', !this.columns[index].hidden);
        },
        setStatusColumn(column) {
            column.hidden = !column.hidden;
            this.setColumnsStore()
        },
        addRowBlank() {
            this.$refs["table-sites"].globalSearchTerm = '';
            this.rows.push(new SiteModel())
        },
        onCellClick(params) {
            // params.row - row object
            // params.column - column object
            // params.rowIndex - index of this row on the current page.
            // params.event - click event
        },
        async getSite(val, index) {
            let app = this;
            for (let i = 0; i < this.rows.length; i++) {
                if (this.rows[i].id === val && !this.rows[index].site_acc_number && i !== index) {
                    if (this.messageId !== val) {
                        showMessage('e', 'The Site Account Number you entered is already in. Please enter a different one.')
                        this.messageId = val
                        setTimeout(() => {
                            app.messageId = null
                        }, 500)
                    }
                    return;
                }
            }

            if (!this.rows[index].site_acc_number) {
                let result = await axios.get('/sites/list-of-ids?ids[0]=' + val)
                if (result.data.rows[0]) {
                    this.rows[index] = result.data.rows[0];
                    this.ids[index] = val;
                    this.rows = JSON.parse(JSON.stringify(this.rows));
                } else {
                    //window.location.reload()
                    //('w','This site has a problem')
                }
            } else if (val === null) {
                this.rows[index] = {}
                this.ids[index] = null;
                this.rows = JSON.parse(JSON.stringify(this.rows));
            }
        },
        async getSites() {
            let app = this;
            let ids = this.ids.map(function (el, index) {
                return `ids[${index}]=${el}`
            }).join('&');
            await axios.get(`/sites/list-of-ids?${ids}&extra_id=${this.extraId}&order=${this.order}&period_id=${this.period_id}&month=${this.month}&year=${this.year}`).then((response) => {
                app.columns = response.data.columns
                if (app.trCondition != null) {
                    app.columns = app.columns.map((e) => {
                        e.tdClass = app.tdClassFunc
                        return e;
                    })
                }
                /*if (app.orderField === "") {
                    app.orderFieldName = app.columns[0].field
                } else {
                    app.orderFieldName = app.orderField
                }*/
                app.rows = response.data.rows
                app.getColumnsStore()

            })
                .catch((err) => {
                    showMessage('e', 'Error loading sites');
                    console.error(err);
                }).finally((e) => app.loading = false)

            this.$root.addTypeButton();


        },
        setSelecteds(sites) {
            this.sites_selecteds = sites;
        },
        async updateSites(id) {
            if (id) {
                this.ids = this.rows.map(function (el) {
                    return el.id;
                })
                this.$forceUpdate()
            }
        },
        addSite() {
            this.ids = this.rows.map(function (el) {
                return el.id;
            })
            if (this.sites_selecteds.length) {
                for (let i = 0; i < this.sites_selecteds.length; i++) {
                    this.ids.push(this.sites_selecteds[i]);
                }
            }
            this.sites_selecteds = []
            this.getSites()
            window.scrollTo({top: -500, behavior: 'smooth'});
            $('#sitesModal').modal('toggle');
            this.$refs["table-sites"].globalSearchTerm = '';


        },
        resetZoomTemporariamente() {
            const meta = document.querySelector('meta[name="viewport"]');
            if (!meta) return;

            const originalContent = meta.getAttribute('content');

            // Força o navegador a "despinçar"
            meta.setAttribute(
                'content',
                'width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no'
            );

            // Restaura o comportamento padrão (com zoom permitido)
            setTimeout(() => {
                meta.setAttribute('content', originalContent || 'width=device-width, initial-scale=1.0');
            }, 300);
        },
        addSiteId(id) {
            this.site_id = id
        }
        ,
        removeSite() {
            let app = this;
            this.$refs["table-sites"].globalSearchTerm = '';
            this.rows = this.rows.filter(function (item) {
                let deleted = false;
                for (let i = 0; i < app.selecteds.length; i++) {
                    if (app.selecteds[i].id === item.id) {
                        deleted = true;
                        break;
                    }
                }
                return !deleted
            })
        }
        ,
        removeAllSite() {
            let app = this;
            this.$refs["table-sites"].globalSearchTerm = '';
            this.rows = []
        }
        ,
        selectionChanged(params) {
            // params.selectedRows - all rows that are selected (this page)
            this.selecteds = params.selectedRows
        }
        ,
        setColumnsStore() {
            localStorage.removeItem('site_columns');
            let columns = this.columns.filter((col) => {
                return !col.hidden
            });
            localStorage.setItem('site_columns', JSON.stringify(columns));
        }
        ,
        getColumnsStore() {
            let columns = localStorage.getItem('site_columns');
            if (columns) {
                columns = JSON.parse(columns)
                this.columns = this.columns.map((col) => {
                    col.hidden = true;
                    for (let i = 0; i < columns.length; i++) {
                        if (columns[i].field === col.field) {
                            col.hidden = false;
                            break;
                        }
                    }
                    return col
                });

            }

            if (this.customField != null) {
                if (this.customFieldPosition === 'start')
                    this.columns.unshift({label: this.customField, field: 'custom_field',});
                else {
                    let lenghtColumn = this.columns.length - 1;
                    if (this.columns[lenghtColumn].field === 'actions') {
                        let lastColumn = this.columns[lenghtColumn];
                        this.columns[lenghtColumn] = {label: this.customField, field: 'custom_field'}
                        this.columns.push(lastColumn);
                    } else {
                        this.columns.push({label: this.customField, field: 'custom_field',});
                    }
                }
            }
        }
        ,
        removeColumnsStore() {
            localStorage.removeItem('site_columns');
            this.getSites()
        }
        ,
        exportExcel() {

            let data = [];
            let header = [];
            header = this.columns.filter((col) => {
                return !col.hidden;
            })

            data.push(header.map((h) => {
                return h.label
            }))

            let fields = header.map((_) => {
                return _.field;
            })

            this.rows.forEach((row) => {
                let r = [];
                for (let i = 0; i < fields.length; i++) {
                    r.push(row[fields[i]])
                }
                data.push(r)
            })

            const fileName = 'sites'
            const exportType = exportFromJSON.types.xls

            exportFromJSON({data, fileName, exportType})
        }
        ,

    }
}
</script>

<style>
.vgt-table td, .vgt-table th {
    padding: 2px !important;
    font-size: 12px;


}

.vgt-table {
    min-height: 100px;
    max-width: 200%;
    width: auto;
}

.vgt-table td {
    height: 60px;
}

.vgt-table td .labor_rate {
    width: 100%;
    height: 100%;
    padding-top: 45%;
    vertical-align: middle;
    display: block;
}

.vgt-left-align {
    vertical-align: middle !important;
}


.lr-black {
    background: black;
    color: white;
}

.lr-red {
    background: #d03131;
    color: white;
}

.vgt-table th.sortable {
    padding-right: 20px !important;
}

/*
.resizable-handle {
    width: 20px;
    height: 20px;
    background-color: #000;
    position: absolute;
    bottom: 0;
    right: 0;
    cursor: se-resize;
}
*/


</style>
